import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { setInputError } from '../inputError/inputErrorSlice'
import { setMessage } from '../message/messageSlice'

const endPoint = process.env.REACT_APP_API_URL

export const inviteErnings = createAsyncThunk(
  'invites/inviteErnings',
  async ({ user }, thunkApi) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await axios.get(
        `${endPoint}/invite-earnings/${user}/`,
        config
      )
      return res
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
)

export const claimInviteErnings = createAsyncThunk(
  'invites/inviteErnings',
  async ({ user, friends_to_inv }, thunkApi) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await axios.post(
        `${endPoint}/invite-earnings/`,
        {user, friends_to_inv},
        config
      )
      return res
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkApi.dispatch(setMessage(message));
      thunkApi.dispatch(setInputError(error.response && error.response.data));
      return thunkApi.rejectWithValue(await error.json());
    }
  }
)